import { render, staticRenderFns } from "./GeneralFormTab.vue?vue&type=template&id=290b372e&scoped=true"
import script from "./GeneralFormTab.vue?vue&type=script&lang=js"
export * from "./GeneralFormTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralFormTab.vue?vue&type=style&index=0&id=290b372e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290b372e",
  null
  
)

export default component.exports